import { cn } from "utils";
const scoreStyle_container_d =
  "bg-gradient-to-b from-[#1A1A1A] to-background_solid_tertiary border-border_white_transparent10 border";

export function RatingScoreCardLazyLoading() {
  return (
    <div
      className={cn("w-full h-[108px] rounded-lg p-5", scoreStyle_container_d)}
    ></div>
  );
}
